import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { GetStateFn } from "../../utils/dispatchUtils";

export const configurationManagerTabViewOptionsSliceName = "configurationManagerTabView";

export enum ConfigurationManagerTabKey {
  CONFIGURATION = "configuration",
  ID_COLOR_MATRIX = "idColorMatrix",
}

export type ConfigurationManagerTabViewOptionsState = {
  selectedTab: ConfigurationManagerTabKey;
};

const persistedConfigurationManagerTabViewOptions = localStorage.getItem(configurationManagerTabViewOptionsSliceName);
const persistedState = persistedConfigurationManagerTabViewOptions ? JSON.parse(persistedConfigurationManagerTabViewOptions) : null;

const fallback: ConfigurationManagerTabViewOptionsState = {
  selectedTab: ConfigurationManagerTabKey.CONFIGURATION,
};

const initialState: ConfigurationManagerTabViewOptionsState = persistedState ?? fallback;

// if selectedTab does not exist, set default fallback value
if (initialState.selectedTab === undefined) initialState.selectedTab = fallback.selectedTab;

const configurationManagerTabViewOptionsSlice = createSlice({
  name: configurationManagerTabViewOptionsSliceName,
  initialState,
  reducers: {
    setLayoutProfileString(_, action: PayloadAction<string>) {
      return JSON.parse(action.payload);
    },
    setConfigurationManagerTabViewSelectedTab(state: ConfigurationManagerTabViewOptionsState, action: PayloadAction<ConfigurationManagerTabKey>) {
      state.selectedTab = action.payload;
    },
  },
});

export type ConfigurationManagerTabViewOptionsRootState = { [configurationManagerTabViewOptionsSliceName]: ConfigurationManagerTabViewOptionsState };
export const selectConfigurationManagerTabViewOptions = (state: ConfigurationManagerTabViewOptionsRootState) => {
  return state[configurationManagerTabViewOptionsSliceName];
};

export const setConfigurationManagerTabViewSelectedTab = (tabKey: ConfigurationManagerTabKey) => (dispatch: Dispatch, getState: GetStateFn) => {
  dispatch(configurationManagerTabViewOptionsSlice.actions.setConfigurationManagerTabViewSelectedTab(tabKey));
  persistState(getState);
};

function persistState(getState: GetStateFn) {
  localStorage.setItem(configurationManagerTabViewOptionsSliceName, JSON.stringify(selectConfigurationManagerTabViewOptions(getState())));
}

export const configurationManagerTabViewOptionsReducer = configurationManagerTabViewOptionsSlice.reducer;
